import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";

export interface EntityLabelsItemProps {
    recordId: string;
    isDisabled: boolean;
    onClick: () => void;
    correctionSelected: boolean;
}

/**
 * This is the entry in the list of DCFs that will be available to the user.
 */
export const EntityLabelsItem = ({ recordId, isDisabled, onClick, correctionSelected }: EntityLabelsItemProps): JSX.Element => {
    return (
        <li
            className="col-md-6"
            style={{ paddingLeft: 5 + "px", paddingRight: 5 + "px" }}
            onClick={isDisabled ? null : onClick}>
            <input type="radio" name={`EntityLabel${recordId}`} value="true" checked={correctionSelected} readOnly disabled={isDisabled} />
            <label>
                <span className="posh-select-icon"><FontAwesomeIcon icon={faPenToSquare} aria-hidden="true" /></span>
                <span className="posh-select-body">
                    <span className="posh-select-title">Move Session</span>
                    <span className="posh-select-description text-muted">Change any of the subject, visit or session labels for this particular session.</span>
                </span>
            </label>
        </li>
    );
}
